import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import StarRatings from "react-star-ratings";
import { homepagee as homepage, apiRoot,ddns}  from "../../../../package.json";

import { Button, Card, CardHeader, CardBody, FormGroup, Form, Input, Row, Col} from "reactstrap";
import { getAll, userFiles, savePrivateInfo} from "network/ApiAxios";
import UserByRoleSelectNoMadal from "components/Reusable Components/UserByRoleSelectNoModal";

const EditEmp = (props) => {
  const history = useHistory();


  const [user, setUser] = useState([]);
  const [rate, setRate] = useState(user ? user.rate : '');
  const [rate2, setRate2] = useState(user ? user.rate2 : '');
  const [notes, setnotes] = useState('');
  const [payrate, setPayRate] = useState(user ? user.payrate : '');
  const [active, setActive] = useState(false);
  const [upload, setUpload] = useState();
  const [role, setRole] = useState(user ? user.role : '');
  const [pic, setPic] = useState('');
  const [house, sethouse] = useState(user ? user.house : '');
  const [cardID, setCardID] = useState('');
  const [managerID, setManagerID] = useState('');
  const [managerName, setManagerName] = useState('');

  const currentRole = JSON.parse(localStorage.getItem('user')).role

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth"
    });
    const userID = props.userID;
    const runAsync = async () => {
      const response = await getAll(userID);
      if(response.data.success){
        setUser(response.data.users[0]);
        setRate(response.data.users[0].rate);
        setRate2(response.data.users[0].rate2);
        setCardID(response.data.users[0].cardID);
        setActive(response.data.users[0].active)
        setnotes(response.data.users[0].notes)
        console.log("manager lo----",response.data.users[0].manager)
        const manager = await getAll(response.data.users[0].manager)
        if(manager.data.users.length >0){
          console.log(manager.data.users)
          setManagerID(manager.data.users[0]._id)
          setManagerName(manager.data.users[0].name)
        }
        if (response.data.users[0].picture) {
          const dat = response.data.users[0].picture;
          setPic(ddns + '/userfiles/' + response.data.users[0].email + '/pics/' + dat);
        } else {
          setPic(require("assets/img/theme/team-1-800x800.jpg").default);
        }

      }
    };
    runAsync();
    // eslint-disable-next-line
  }, []);

  const saveUser = async (e) => {
    e.preventDefault();//userID, rate, rate2, notes, payrate, active,  role,house,manager, cardID
    const res = managerID ? await savePrivateInfo({userID:user._id,rate:rate,rate2:rate2,notes:notes,payrate:payrate,active:active,role:role,house:house,managerID:managerID,cardID:cardID})
    :await savePrivateInfo({userID:user._id,rate:rate,rate2:rate2,notes:notes,payrate:payrate,active:active,role:role,house:house,cardID:cardID})
    if (res.data.success) {
      history.go(0)
    }
  };

  const uploadFile = async (e) => {
    setUpload("File is uploading....");
    const files = new FormData();
    files.append("doc", e.target.files[0]);
    files.append("userID", user._id);
    files.append("email", user.email);
    var resp = await userFiles(files);
    if (resp.data.success) {
      setUpload("You can now upload more files");
    }
  };

  return (
    <>
        <Row>
          <div className="col">
            <Card className="bg-secondary shadow">
              <CardHeader className="bg-white border-0">
                <Row className="align-items-center">
                  <Col xs="8">
                    <h3 className="mb-0"> User information </h3>
                  </Col>
                  <Col className="text-right" xs="4">
                    {currentRole == 'admin' ? <Button
                      color="primary"
                      type="submit"
                      form="myform"
                      size="sm"
                    >
                      Save
                    </Button> : null}
                  </Col>
                </Row>
              </CardHeader>
              <CardBody>
                <Form id="myform" onSubmit={saveUser}>
                  <div className="pl-lg-4">
                    <h6 className="heading-small text-muted mb-4">
                      User information
                    </h6>
                    <Row>
                      <Col lg="6">
                        <FormGroup>
                          <label
                            className="form-control-label"
                            htmlFor="input-username"
                          >
                            Username
                          </label>
                          <p></p>
                          <label>{user.name}</label>
                        </FormGroup>
                      </Col>
                      <Col lg="6">
                        <FormGroup>
                          <label
                            className="form-control-label"
                            htmlFor="input-email"
                          >
                            Email address
                          </label>
                          <p></p>
                          <a href={"mailto:" + user.email}>{user.email}</a>
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col lg="6">
                        <FormGroup>
                          <label
                            className="form-control-label"
                            htmlFor="input-phone"
                          >
                            Phone Number
                          </label>
                          <p></p>
                          <a href={"tel:" + user.phone}>{user.phone}</a>
                        </FormGroup>
                      </Col>
                      <Col lg="6">
                        <FormGroup>
                          <label
                            className="form-control-label"
                            htmlFor="input-birthday"
                          >
                            Birthday
                          </label>
                          <p></p>
                          <label>
                            {new Date(user.birthday).toDateString()}
                          </label>
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col lg='6'></Col>
                      <Col lg="6" >
                        <FormGroup>
                          <label
                            className="form-control-label"
                            htmlFor="input-profilepicture"
                          >
                            Profile Picture
                          </label>
                          <p></p>
                          <img
                            alt="..."
                            className="form-control-alternative ml-5"
                            style={{ height: "150px" }}
                            src={pic}
                            id="input-profilepicture"
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    <hr></hr>
                    <h6 className="heading-small text-muted mb-4">
                      User Address
                    </h6>
                    <Row>
                      <Col lg="6">
                        <FormGroup>
                          <label
                            className="form-control-label"
                            htmlFor="input-adress"
                          >
                            Address
                          </label>
                          <p></p>
                          <label>{user.adress}</label>
                        </FormGroup>
                      </Col>
                      <Col lg="6">
                        <label
                          className="form-control-label"
                          htmlFor="input-country"
                        >
                          Country
                        </label>
                        <p></p>
                        <label>{user.country}</label>
                      </Col>
                    </Row>
                    <hr></hr>
                    <h6 className="heading-small text-muted mb-4">
                      User ID and Drivers license
                    </h6>
                    <Row>
                      <Col lg="6">
                        <FormGroup>
                          <label
                            className="form-control-label"
                            htmlFor="input-idpicture"
                          >
                            ID picture
                          </label>
                          <p></p>
                          <img
                            alt="..."
                            className="form-control-alternative"
                            style={{ height: "150px" }}
                            src={
                              user.IDpicture ? apiRoot + '/userfiles/' + user.email + '/pics/' + user.IDpicture : ""
                            }
                          />
                        </FormGroup>
                      </Col>
                      <Col lg="6">
                        <FormGroup>
                          <label
                            className="form-control-label"
                            htmlFor="input-driverlicense"
                          >
                            Picture Drivers License
                          </label>
                          <p></p>
                          <img
                          alt="..."
                            className="form-control-alternative"
                            style={{ height: "150px" }}
                            src={
                              user.driverlicense
                                ? apiRoot + '/userfiles/' + user.email + '/pics/' + user.driverlicense
                                : ""
                            }
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    <hr></hr>
                    <h6 className="heading-small text-muted mb-4">
                      Private information(ADMINS ONLY)
                    </h6>
                    <Row>
                      <Col lg="6">
                        <FormGroup>
                          <label
                            className="form-control-label"
                            htmlFor="input-driverlicense"
                          >
                            Rating 1
                          </label>
                          <p></p>
                          <StarRatings
                            rating={rate ? rate : 0}
                            starRatedColor="blue"
                            changeRating={setRate}
                            numberOfStars={5}
                            name="rating"
                            starDimension="30px"
                            starSpacing="2px"
                            onChange={(e) => setRate(e.target.value)}
                          />
                        </FormGroup>
                      </Col>
                      <Col lg="6">
                        <FormGroup>
                          <label
                            className="form-control-label"
                            htmlFor="input-driverlicense"
                          >
                            Rating 2
                          </label>
                          <p></p>
                          <StarRatings
                            rating={rate2 ? rate2 : 0}
                            starRatedColor="blue"
                            changeRating={setRate2}
                            numberOfStars={5}
                            name="rating"
                            starDimension="30px"
                            starSpacing="2px"
                            onChange={(e) => setRate2(e.target.value)}
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col lg="6">
                        <FormGroup>
                          <label
                            className="form-control-label"
                            htmlFor="input-payrate"
                          >
                            Pay Rate(hourly)
                          </label>
                          <p></p>
                          <Input
                            className="form-control-alternative"
                            id="input-payrate"
                            placeholder={user.payrate}
                            onChange={(e) => setPayRate(e.target.value)}
                            type="number"
                          />
                        </FormGroup>
                      </Col>
                      <Col lg="6">
                        <FormGroup>
                          <label
                            className="form-control-label"
                            htmlFor="activechk"
                          >
                            Enable/Disable User
                          </label>
                          <p></p>
                          <Input
                            className="form-control-alternative"
                            style={{
                              height: "25px",
                              width: "25px",
                              left: "50%",
                            }}
                            checked={active}
                            onChange={(e) => {
                              setActive(!active)
                            }}
                            type="checkbox"
                            id="activechk"
                          />
                          <p></p>
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row className="mt-6">
                      <Col lg="6">
                        <FormGroup>
                          <label
                            className="form-control-label"
                            htmlFor="input-Accomodation"
                          >
                            Accomodation
                          </label>
                          <p></p>
                          <label>Room number:{user.accomodation}</label>
                        </FormGroup>
                      </Col>
                      <Col lg="6">
                        <FormGroup>
                          <label
                            className="form-control-label"
                            htmlFor="input-Documents"
                          >
                            Upload Documents to user{" "}
                            {upload ? (
                              <span style={{ color: "green" }}> {upload} </span>
                            ) : (
                              ""
                            )}
                          </label>
                          <Input
                            className="form-control-alternative"
                            id="input-Documents"
                            placeholder="Upload Documents"
                            //value={user.instagram}
                            onChange={uploadFile}
                            type="file"
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col lg="6">
                        <FormGroup>
                          <label
                            className="form-control-label"
                            htmlFor="input-idpicture"
                          >
                            Role - 
                          </label>
                            {' ' + user.role}
                          <p></p>
                          <Input
                            type="select"
                            name="select"
                            id="exampleSelect"
                            onChange={(e) => setRole(e.target.value)}
                          >
                            <option>Select 1</option>
                            <option>admin</option>
                            <option>user</option>
                            <option>seller</option>
                            <option>shop</option>
                            <option>manager</option>
                            <option>sellermanager</option>
                            <option>cleaner</option>
                            <option>security</option>
                          </Input>
                        </FormGroup>
                        <Row>
                          <Col lg="6">
                            <FormGroup>
                              <label
                                className="form-control-label"
                                htmlFor="input-facebook"
                              >
                                House - 
                              </label>
                              {' ' + user.house}
                              <p></p>
                              <Input
                                type="select"
                                name="select"
                                id="exampleSelect"
                                onChange={(e) => sethouse(e.target.value)}
                              >
                                <option>Select 1</option>
                                <option>Heaven</option>
                                <option>Albufeira66</option>
                                <option>Albufissa</option>
                                <option>Tropicana</option>
                                <option>Warehouse</option>
                                <option>TicketSeller</option>
                                <option>BeachClub</option>
                                <option>Other</option>
                              </Input>
                            </FormGroup>
                          </Col>
                        </Row>
                      </Col>
                      <Col lg="6">
                        <FormGroup>
                          <label
                            className="form-control-label"
                            htmlFor="input-idpicture"
                          >
                            Private Notes
                          </label>
                          <Input
                            className="form-control-alternative"
                            value={user.notes}
                            id="input-birthday"
                            onChange={(e) => setnotes(e.target.value)}
                            type="textarea"
                            style={{ height: "100px" }}
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col lg='6'>
                          <label
                            className="form-control-label"
                            htmlFor="input-cardID"
                          >
                            Card ID
                          </label>
                          <Input
                            className="form-control-alternative"
                            value={cardID}
                            id="input-cardID"
                            onChange={(e) => setCardID(e.target.value)}
                            type="text"
                          />
                      </Col>
                      <Col lg='6'>
                          <label
                            className="form-control-label"
                            htmlFor="input-cardID"
                          >
                            Manager- {' ' + managerName}
                          </label>
                          <UserByRoleSelectNoMadal role={'manager'} handler={setManagerID}/>
                      </Col>
                    </Row>
                  </div>
                </Form>
              </CardBody>
            </Card>
          </div>
        </Row>
      
    </>
  );
};

export default EditEmp;
